import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { getAssets } from 'src/routes/Checkout/store/selectors/assets';
import { getIsMobile } from 'src/store/view/selectors';
import PackageRoomInfo from './PackageRoomInfo';
import {
  getHotelImageSmall,
  getHotelRoulette,
  getHotelTitle,
  getOperatorRoomNameWithRoulette,
} from '../../../store/selectors/hotel';
import { getRoomInfo } from '../../../store/selectors/package';
import { equalsIgnoreCase } from '../../../../../utils/stringUtils';

const mapStateToProps = (state) => {
  const isRoulette = getHotelRoulette(state);
  const roomInfo = getRoomInfo(state);
  const { name_ru, altName, description } = roomInfo;
  const hotelImg = getHotelImageSmall(state);
  const roomType = getOperatorRoomNameWithRoulette(state);
  const assets = getAssets(state);
  const roomDescription = isRoulette
    ? getHotelTitle(state)
    : altName || description;
  const image = isRoulette
    ? assets['packages/fortuna-room@2x.jpg']
    : get(roomInfo, 'images[0].x100x110', hotelImg);
  const isMobile = getIsMobile(state);

  return {
    image, // фото номера или фото отеля
    roomDescription,
    roomType: equalsIgnoreCase(name_ru, roomType) ? null : roomType,
    isMobile,
  };
};

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(PackageRoomInfo);
